import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";

export default function Herbs() {
  const { data: herbs = [], isLoading } = useQuery({
    queryKey: ["herbs"],
    queryFn: () => api.get("/herbs").then((r) => r.data),
  });

  return (
    <div className="mx-auto max-w-6xl px-5 sm:px-8 pt-12">
      <header className="max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-widest text-brand-sage">Herb Library</span>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl text-brand-ink tracking-tight">Medicinal herbs</h1>
        <p className="mt-4 text-brand-muted">
          Traditional uses, properties and — importantly — safety considerations for each herb.
        </p>
      </header>

      {isLoading ? (
        <p className="mt-16 text-center text-brand-muted">Loading…</p>
      ) : (
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {herbs.map((h, i) => (
            <motion.div
              key={h.slug}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.07 }}
            >
              <Link to={`/herbs/${h.slug}`} data-testid={`herb-${h.slug}`} className="group flex gap-4 overflow-hidden rounded-xl border border-brand-line bg-white p-4 shadow-sm transition-transform hover:-translate-y-1">
                <div className="h-24 w-24 shrink-0 overflow-hidden rounded-lg">
                  <img src={h.image} alt={h.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-brand-ink group-hover:text-brand">{h.name}</h3>
                  <p className="text-xs italic text-brand-muted">{h.botanical}</p>
                  <p className="mt-1.5 line-clamp-2 text-sm text-brand-muted">{h.summary}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
